export default __webpack_public_path__ + "static/media/890.f03bc626.png";